(() => {
  class GridBlockElement {
    constructor(inner) {
      this.inner = inner;

      this.cellWidth = parseInt(
        getComputedStyle(this.inner).getPropertyValue(
          "--luther--grid--cell-width"
        ),
        10
      );
      this.paddingHorizontal = parseInt(
        getComputedStyle(this.inner).getPropertyValue(
          "--luther--grid--gap-horizontal"
        ),
        10
      );

      this._setColumnsVariable();
      window.addEventListener("resize", this._setColumnsVariable.bind(this));
    }

    _setColumnsVariable() {
      const containerWidth = this.inner.offsetWidth;
      const cellWidth = this.cellWidth;
      const paddingHorizontal = this.paddingHorizontal;

      const columnsCount = Math.floor(
        (containerWidth + paddingHorizontal) / (cellWidth + paddingHorizontal)
      );

      this.inner.style.setProperty(
        "--luther--grid--columns-count",
        columnsCount
      );
    }
  }

  window?.luther?.eventBus?.on(
    "luther:pageContentChange",
    updateLutherGridInstances
  );

  function updateLutherGridInstances() {
    document
      .querySelectorAll(
        ".luther-grid > .luther-grid-inner.has-dymamic-cell-width-calculation"
      )
      .forEach((el) => {
        let wrapper = new GridBlockElement(el);
        window.luther.grids.push(wrapper);
      });
  }

  window.luther = window.luther || {};
  window.luther.grids = [];
  updateLutherGridInstances();
})();
